<div class="col-sm-6 col-xs-12">
    <fieldset [ngModelGroup]="groupName">
        <label [i18n]="[{target: 'innerHTML', key: translationNode + '.label'}]"></label>

        <div>
            <select class="form-control" [name]="groupName + 'Value'" [(ngModel)]="model" [disabled]="disabled" (change)="modelChanged()">
                <option *ngIf="regionValue" [ngValue]="'INHERITED'" [i18n]="[{target: 'innerHTML', key: 'feature-profiles.editor.inherited', params: {regionValue: regionValue}}]">feature-profiles.editor.inherited</option>
                <option *ngFor="let possibleValue of possibleValues"
                        [ngValue]="possibleValue.value"
                        [i18n]="[{target: 'innerHTML', key: possibleValue.labelKey}]">
                </option>
            </select>
        </div>
        <div class="warning-message" *ngIf="hasError">
            <i class="fa fa-warning space-right-5"></i>
            <span [i18n]="warningLabelKey"></span>
        </div>
        <div>
            <small class="help-block" [i18n]="[{target: 'innerHTML', key: translationNode + '.description'}]"></small>
        </div>
    </fieldset>
</div>
